import React from 'react';

const ListCard = () => {
	return (
		<div>
			<p>List Card Component</p>
		</div>
	);
};

export default ListCard;
